
define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var ContentSystemMessagingBaseModel = require("content-models/system-messaging/ContentSystemMessagingBaseModel");
    var ContentSystemMessagingUtilities = require("content-utils/ContentSystemMessagingUtilities");
    var systemMessageConfig = require("content-config/systemMessageConfig.json");
    var validationConfig = require("content-config/contentSystemMessagingValidationConfig.json");
    var LocaleResolver = require("i18n/localeResolver");
    var CONST = require("const");

    var KEYS = {
        TIMER: "timer",
        TIMER_UNIT: "timerUnit",
        SKILLS: "contexts.SKILL",
        CONTEXTS: "contexts",
        SKILL: "SKILL",
        ACCOUNT: "ACCOUNT"
    };

    var URL_TYPE = {
        GET: "GET",
        UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
        UPDATE_SKILL: "UPDATE_SKILL",
        DELETE: "DELETE",
        DELETE_ACCOUNT: "DELETE_ACCOUNT"
    };

    var STATUS = {
        ENABLED: "enabled",
        MULTIPLE: "multiple",
        DISABLED: "disabled"
    };

    var TIMER_UNITS = {
        SECONDS: "seconds",
        MINUTES: "minutes",
        HOURS: "hours"
    };

    var ContentSystemMessagingModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemMessagingModel = ContentSystemMessagingBaseModel.extend({
            resource: ApiResources.AccountConfig.SystemMessagingMessages,
            name: "ContentSystemMessagingModel",
            type: null,
            initialize: function(options){
                ContentSystemMessagingBaseModel.prototype.initialize.call(this, options);
            },
            url: function(){
                var url = ContentSystemMessagingBaseModel.prototype.url.call(this);
                switch(this.type) {
                    case URL_TYPE.UPDATE_SKILL:
                    case URL_TYPE.DELETE:
                        return url += "&context_type=SKILL&context_id=" + this.getSkillId();
                    case URL_TYPE.DELETE_ACCOUNT:
                        return url;
                    case URL_TYPE.UPDATE_ACCOUNT:
                        return url;
                    default:
                        return url;
                }
            },
            save: function(attributes, options, isSkillContext) {
                attributes = attributes || {};
                options = options || {};
                if(isSkillContext) {
                    this._setUrlType(URL_TYPE.UPDATE_SKILL);
                    return ContentSystemMessagingBaseModel.prototype.save.call(this, attributes, options);
                } else {
                    this._setUrlType(URL_TYPE.UPDATE_ACCOUNT);
                    //prepare temp model for the save - as we need to remove al the defaults
                    var tempModel = this.createModelOnlyWithChanges();

                    //validation is not really important here so no need to catch onInvalid on tempModel and trigger it on realModel.

                    //pass the revision from the tempModel to the realModel - as it changed after the save
                    var success = options.success;
                    options.success = _.bind(function(model, resp, options) {
                        this.setRevision(tempModel.getRevision(true));

                        if (success) {
                            success(model, resp, options);
                        } //call original success function
                    },this);
                    if (_.isEmpty(tempModel.getData()) &&
                        _.isEmpty(tempModel.getAttrs()) &&
                        tempModel.getEnabledState() === this.defaults.enabled){
                        return this.destroy(options, true);
                    }
                    else {
                        return ContentSystemMessagingBaseModel.prototype.save.call(tempModel, attributes, options);
                    }
                }

            },
            createModelOnlyWithChanges: function() {
                var defaultModel = LEContent.getDataManager().getDefaultMessagingAutoMessagesModel(this.id);
                var tempModel = this.clone();

                tempModel.setRevision(this.getRevision());
                //remove all languages that are default
                var newData = [];
                _.each(tempModel.getData(),function(langObj){
                    if (langObj.msg !== defaultModel.getContentMessage(langObj.lang)){
                        newData.push(langObj);
                    }
                });
                tempModel.setData(newData);

                //remove default attributes
                if (!_.isEmpty(defaultModel.getAttrs()) &&
                    defaultModel.getTimer() === tempModel.getTimer() &&
                    defaultModel.getTimerUnit() === tempModel.getTimerUnit()){
                    tempModel.setAttrs({});
                }

                return tempModel;
            },
            destroy: function(options, isAccountContext) {
                options = options || {};
                this._setUrlType(isAccountContext ? URL_TYPE.DELETE_ACCOUNT : URL_TYPE.DELETE);
                return ContentSystemMessagingBaseModel.prototype.destroy.call(this, options);
            },
            _cleanLanguagesWithErrors: function(languages) {
                var languagesToRemove = [];
                _.each(this.languagesWithErrors, _.bind(function(lang, index){
                   var ind = languages.indexOf(lang);
                   if (ind < 0) {
                       languagesToRemove.push(lang);
                   }
                }, this));
                this.languagesWithErrors = _.difference(this.languagesWithErrors, languagesToRemove);
            },
            validateSaveEnabled:function (lang, languages) {
                this._cleanLanguagesWithErrors(languages);
                var isTimerValid = this.validateOnHoldTimer();
                var isContentValid = this.validateContentMessage(lang);
                var tooltip = "";
                if (!isTimerValid) {
                    tooltip = this.saveNoTimerTooltip();
                }
                else if (!isContentValid) {
                    tooltip = this.saveContentMessageLengthTooltip();
                }
                return {
                    isSaveValid: isTimerValid && isContentValid,
                    tooltip: tooltip,
                    isContentValid: isContentValid
                };
            },
            validateContentMessage: function(selectedLanguage) {
                var msg = this.getContentMessage(selectedLanguage);
                if (msg.length <= systemMessageConfig.maxMessageSize.messaging) {
                    this.languagesWithErrors = _.reject(this.languagesWithErrors, function(lang) {
                        return lang === selectedLanguage;
                    });
                }
                else {
                    this.languagesWithErrors = _.union(this.languagesWithErrors ,[selectedLanguage]);
                }
                return _.isEmpty(this.languagesWithErrors);
            },
            initLanguagesWithErrors: function() {
                this.languagesWithErrors = [];
            },
            getLanguagesWithErrors: function() {
                return this.languagesWithErrors;
            },
            validateOnHoldTimer: function() {
                if (this.isOnHoldMessage()) {
                    var timer = this.getTimer();
                    return (_.isString(timer) && !_.isEmpty(timer)) || _.isNumber(timer); //if timer exists - make sure it's not empty string or it is a number.
                }
                return true;
            },
            hasContent: function(lang){
                return this.hasContentMessage(lang);
            },
            hasTitleField: function() {
                return false;
            },
            getValidationConfig: function(){
               return validationConfig;
            },
            getTimerKey: function(){
                return ContentSystemMessagingBaseModel.KEYS.ATTRIBUTES + "."  + KEYS.TIMER;
            },
            getTimerUnitKey: function(){
                return ContentSystemMessagingBaseModel.KEYS.ATTRIBUTES + "."  + KEYS.TIMER_UNIT;
            },
            setTimer: function(time){
                if (this.isOnHoldMessage()) {
                    this.set(this.getTimerKey(), time);
                }
            },
            getTimer: function(){
                return this.get(this.getTimerKey());
            },
            setTimerUnit: function(unit){
                if (this.isOnHoldMessage()) {
                    this.set(this.getTimerUnitKey(), unit);
                }
            },
            getTimerUnit: function(){
                return this.get(this.getTimerUnitKey());
            },

            getName: function(){//TODO ivanm check it
                var eventNameKey =  'LEContent.content.system.messaging.event.' + this.getEventId().toString() + ".name";
                return this._getTranslatedName(eventNameKey);
            },
            getNameForEditPage: function(){ //TODO ivanm check it
                var eventNameKey =  'LEContent.content.system.messaging.edit.event.' + this.getEventId().toString() + ".name";
                return this._getTranslatedName(eventNameKey);
            },
            _getTranslatedName: function(eventNameKey){
                //get name in this order: Interface language, Default account language, en-US
                var chosenLocale = _.find([LocaleResolver.getLocale(),LE.siteSettings.supportedLanguageSettings.getDefaultLanguage()],function(locale){
                    return  LE.translator.hasTranslationKey(locale, eventNameKey);
                },this);

                if (!chosenLocale) {
                    chosenLocale = CONST.LANGUAGE["en-US"];
                }

                return LE.translator.translate(eventNameKey,chosenLocale);
            },
            getSkills: function(){
                return this.get(KEYS.SKILLS);
            },
            setSkills: function(skillsArray){
                this.set(KEYS.SKILLS, skillsArray);
            },
            //jasonized settings
            isOnHoldMessage: function(){
                if(this.isNotEmptyModel()) {
                    return  ContentSystemMessagingUtilities.isTimerAllowed(this.getEventId());
                }
                return false;
            },
            isEnabledEditable: function(){
                if(this.isNotEmptyModel()) {
                    return  ContentSystemMessagingUtilities.isEnabledEditable(this.getEventId());
                }
                return false;
            },
            getStatusState: function() {
                var status = this.get(ContentSystemMessagingBaseModel.KEYS.ENABLED);
                _.find(this.get(KEYS.SKILLS), function(skill) {
                    if(status !== skill.enabled) {
                        status = STATUS.MULTIPLE;
                        return true;
                    }
                }, this);
                if(status === STATUS.MULTIPLE) {
                    return status;
                }
                return status ? STATUS.ENABLED : STATUS.DISABLED;
            },
            getAllowedMacros: function(){
                if(this.isNotEmptyModel()) {
                    return ContentSystemMessagingUtilities.macros(this.getEventId());
                }
                return false;
            },
            getAllSystemMessagingMacros: function(){
                return ContentSystemMessagingUtilities.allAvailableMacroValues();
            },

            saveEmptyTooltip: function(){
                return ContentSystemMessagingUtilities.saveEmptyTooltip();
            },
            saveNoChangesTooltip: function () {
                return ContentSystemMessagingUtilities.saveNoChangesTooltip();
            },
            saveNoTimerTooltip: function() {
                return ContentSystemMessagingUtilities.saveNoTimerTooltip();
            },
            saveContentMessageLengthTooltip: function() {
                return ContentSystemMessagingUtilities.saveContentMessageLengthTooltip();
            },
            getHeaderTexts: function() {
                return ContentSystemMessagingUtilities.getHeaderTexts(this.isOnHoldMessage());
            },
            cleanData: function() {
                var newData  = [];

                _.each(this.getData(),function(content){
                     if (!_.isEmpty(content.msg) ){
                         newData.push(content);
                     }

                },this);
                this.setData(newData);
            },
            _setUrlType: function(type){
                this.type = type;
            },
            setSkillId: function(skillId){
                this.skillId = skillId;
            },
            getSkillId: function(){
                return this.skillId;
            },
            setSelectedLanguage: function(selectedLanguage){
                this.selectedLanguage = selectedLanguage;   //todo noam/Ivan CR check why not save on pageModel
            },
            getSelectedLanguage: function(){
                return this.selectedLanguage;
            },
            isNotEmptyModel: function() {
                return !!this.id;
            },
            parse: function(response, options) {
                if (response[KEYS.CONTEXTS]) {
                    response[KEYS.CONTEXTS][KEYS.SKILL] = response[KEYS.CONTEXTS][KEYS.SKILL] || [];
                    response[KEYS.CONTEXTS][KEYS.ACCOUNT] = response[KEYS.CONTEXTS][KEYS.ACCOUNT] || [];
                }

                return ContentSystemMessagingBaseModel.prototype.parse.call(this, response, options);
            }
        });
    });

    ContentSystemMessagingModel.STATUS = STATUS;
    ContentSystemMessagingModel.TIMER_UNITS = TIMER_UNITS;

    return ContentSystemMessagingModel;
});
